export function isEqual(a: any, b: any): boolean {
  if (a === b) {
    return true
  }
  const keys_a = Object.keys(a).sort()
  const keys_b = Object.keys(b).sort()
  if (keys_a.length !== keys_b.length) {
    return false
  }
  for (let i = 0; i < keys_a.length; i++) {
    const key_a = keys_a[i]
    const key_b = keys_b[i]
    const value_a = a[key_a]
    const value_b = b[key_b]
    if (key_a !== key_b || value_a !== value_b) {
      if (typeof value_a === 'object' && typeof value_b === 'object') {
        if (!isEqual(value_a, value_b)) {
          return false
        }
      } else {
        return false
      }
    }
  }
  return true
}
